import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'
import LogoTiles from '@segment/templates/LogoTiles'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import InternalSecurity from './components/InternalSecurity'
import Testimonial from './components/Testimonial'
import ProductSecurity from './components/ProductSecurity'
import BugBountyProgram from './components/BugBountyProgram'
import Certifications from './components/Certifications'
import Articles from './components/Articles'
import CommitmentToDataPrivacy from './components/CommitmentToDataPrivacy'

import ogImagePng from './assets/OgSecurity.png'

const Security: FC<PropsWithChildren<unknown>> = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Security | Twilio Segment"
        pageDescription="We take the responsibility of helping you manage your customer data seriously."
        pageOG={ogImagePng}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <InternalSecurity />
          <ProductSecurity />
          <BugBountyProgram />
          <Certifications />
          <CommitmentToDataPrivacy />
          <Articles />
          <Testimonial />
          <WrapperLogoTiles>
            <LogoTiles />
          </WrapperLogoTiles>
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const WrapperLogoTiles = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const Main = styled.main`
  /* Give a main content a background color, so sections don't flash from white background */
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default Security
